import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { defaultPagingChoices, buyLimitErrors } from "@/js/lists.ts";
import * as orderHandler from "@/js/order/order.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import WineCard from "@/components/products/WineCard.vue";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import TargetSelectors from "@/components/order/TargetSelector/TargetSelectors.vue";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "FavoriteList",
  components: {
    "wine-card": WineCard,
    paging: pagingComponent,
    index: indexComponent,
    confirm: confirmationComponent,
    TargetSelectors: TargetSelectors,
    WineStockListModal: WineStockListModal,
    ErrorModal: ErrorModal
  },
  props: {
    searchCriterias: {
      name: "",
      paging: {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      },
      label: "",
      vintage: null
    },
    loggedUserData: Object
  },
  data: function data() {
    return {
      isAddingToCart: [],
      loadingSearch: false,
      cancellationTokenSearch: null,
      baseModel: {
        wines: [],
        numberOfWines: 0,
        numberOfPages: 0
      },
      errorMessages: {
        criteria: {
          format: "The criterias are incorrect"
        }
      },
      quantityByWine: [],
      thirdPartyOrder: false,
      wineStockKey: null,
      currentWine: null,
      casingIdSelected: "",
      currentQuantity: 0,
      pagingLimitsChoices: defaultPagingChoices,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.loadingSearch && this.baseModel.numberOfWines > 0;
    }
  },
  created: function created() {
    this.thirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
    orderHandler.refreshCategoryUser(this);
  },
  mounted: function mounted() {
    this.search();
  },
  methods: {
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    search: function search() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$cancellationTok;
        var isResetPaging, _this, criterias, thirdPartyUserSelected, pricePostingSelected, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isResetPaging = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this = _this2;
              if (isResetPaging) _this.resetPaging();
              _this.loadingSearch = true;
              criterias = _objectSpread({}, _this.searchCriterias);
              criterias.filters = _objectSpread({}, criterias.filters);
              thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
              if (!!thirdPartyUserSelected) {
                criterias.userIdTarget = thirdPartyUserSelected === null || thirdPartyUserSelected === void 0 ? void 0 : thirdPartyUserSelected.id_user;
              }
              criterias.isApplyActivePricePostingByDefault = false;
              pricePostingSelected = orderHandler.getPricePostingUsaSelected();
              if (!!pricePostingSelected) {
                criterias.pricePostingUsaProId = pricePostingSelected.id;
              }
              (_this$cancellationTok = _this.cancellationTokenSearch) === null || _this$cancellationTok === void 0 || _this$cancellationTok.cancel();
              _this.cancellationTokenSearch = axios.CancelToken.source();
              _context.next = 15;
              return request("/v1/user/favorites", "post", criterias, true, "api", null, _this.cancellationTokenSearch).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get favorites");
                  handleErrorData(_this, errorData);
                  _this.loadingSearch = false;
                }
                throw e;
              });
            case 15:
              response = _context.sent;
              _this2.baseModel.wines.splice(_this.searchCriterias.paging.limits);
              _this2.baseModel = {
                wines: response.data.wines,
                numberOfWines: response.data.total_number,
                numberOfPages: Math.ceil(response.data.total_number / _this.searchCriterias.paging.limits)
              };
              _this2.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
              if (!_this2.searchCriterias.paging.currentPage) {
                _this2.searchCriterias.paging.currentPage = 0;
              }
              _this2.loadingSearch = false;
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    advancedSearch: function advancedSearch() {
      this.searchCriterias.paging.askedPage = 0;
      this.search();
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.wineStockKey = null;
        _this3.currentWine = null;
        _this3.casingIdSelected = "";
        _this3.currentQuantity = 0;
      });
    },
    addItemToCart: function addItemToCart(wine, casingId) {
      var _arguments2 = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _wine$stocks;
        var isFromWineStockModal, quantityFromStockModal, quantity, element, casing, isBypassingReachedBuyLimit, _this, currentOrder, _this5, _this6, index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isFromWineStockModal = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : false;
              quantityFromStockModal = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : 0;
              if (!(_this4.thirdPartyOrder && !orderHandler.getThirdPartyUserSelected())) {
                _context4.next = 5;
                break;
              }
              _this4.$toasted.show("You should choose a user before adding an item to your basket.", {
                type: "warning"
              });
              return _context4.abrupt("return");
            case 5:
              // We get the quantity set by the user, default 1
              quantity = 1;
              if (quantityFromStockModal > 0) {
                quantity = quantityFromStockModal;
                _this4.wineStockKey = null;
                _this4.currentWine = null;
                _this4.casingIdSelected = "";
                _this4.currentQuantity = 0;
              } else {
                element = _this4.quantityByWine.filter(function (q) {
                  return q.id_wine === wine.id_wine;
                })[0];
                if (typeof element != "undefined") {
                  // otherwise we set the item with the quantity typed
                  quantity = element.quantity;
                }
              }
              if (!(!isFromWineStockModal && isAdminNotConsultant(_this4.loggedUserData) && ((_wine$stocks = wine.stocks) === null || _wine$stocks === void 0 ? void 0 : _wine$stocks.length) >= 1)) {
                _context4.next = 15;
                break;
              }
              _this4.wineStockKey = wine.id_wine;
              _this4.currentWine = wine;
              _this4.casingIdSelected = casingId;
              _this4.currentQuantity = parseInt(quantity);
              _this4.$nextTick(function () {
                _this4.$refs.WineStockListModal.open();
              });
              _context4.next = 35;
              break;
            case 15:
              _this4.isAddingToCart = [].concat(_toConsumableArray(_this4.isAddingToCart), [wine.id_wine]);

              // Perform casing adjustment
              casing = casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              isBypassingReachedBuyLimit = null;
              _this = _this4;
              _context4.next = 22;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this4.$toasted, _this4).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
                  var _e$value;
                  var _e$value$errorMessage, _e$value2, _e$value3, errorMessage;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.isAddingToCart = _toConsumableArray(_this.isAddingToCart.filter(function (x) {
                          return x !== wine.id_wine;
                        }));
                        if (!((e === null || e === void 0 || (_e$value = e.value) === null || _e$value === void 0 ? void 0 : _e$value.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context2.next = 7;
                          break;
                        }
                        _this4.$toasted.clear();
                        errorMessage = (_e$value$errorMessage = e === null || e === void 0 || (_e$value2 = e.value) === null || _e$value2 === void 0 ? void 0 : _e$value2.errorMessage) !== null && _e$value$errorMessage !== void 0 ? _e$value$errorMessage : e === null || e === void 0 || (_e$value3 = e.value) === null || _e$value3 === void 0 ? void 0 : _e$value3.message;
                        _context2.next = 6;
                        return _this.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 6:
                        isBypassingReachedBuyLimit = _context2.sent;
                      case 7:
                        return _context2.abrupt("return");
                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 22:
              if (!isBypassingReachedBuyLimit) {
                _context4.next = 33;
                break;
              }
              currentOrder = orderHandler.getCurrentOrder();
              if (!currentOrder) {
                _context4.next = 30;
                break;
              }
              _this5 = _this4;
              _context4.next = 28;
              return request("/v1/order/".concat(currentOrder.id_order, "/bypass"), "put", null, true, "api").then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resp) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return orderHandler.addItemToCart(wine, quantity, casingId, _this5.$toasted, _this5, true).catch(function () {
                          _this5.isAddingToCart = _toConsumableArray(_this5.isAddingToCart.filter(function (x) {
                            return x !== wine.id_wine;
                          }));
                        });
                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 28:
              _context4.next = 33;
              break;
            case 30:
              _this6 = _this4;
              _context4.next = 33;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this4.$toasted, _this4, true).catch(function () {
                _this6.isAddingToCart = _toConsumableArray(_this6.isAddingToCart.filter(function (x) {
                  return x !== wine.id_wine;
                }));
              });
            case 33:
              index = _this4.isAddingToCart.indexOf(wine.id_wine);
              _this4.isAddingToCart.splice(index, 1);
            case 35:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeQuantityOrder: function changeQuantityOrder(_ref3) {
      var idWine = _ref3.idWine,
        quantity = _ref3.quantity;
      if (typeof this.quantityByWine.filter(function (q) {
        return q.id_wine === idWine;
      })[0] == "undefined") {
        // unknown reference for this session of shopping, we add it to the array
        this.quantityByWine.push({
          id_wine: idWine,
          quantity: quantity
        });
      } else {
        // Already add a value, so we update it
        var element = this.quantityByWine.filter(function (q) {
          return q.id_wine === idWine;
        })[0];
        element.quantity = quantity;
      }
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};